import * as React from 'react';
import { Col, Row } from 'react-bootstrap';

class AboutUs extends React.Component {
  render() {
    return (
      <Row>
        <Col md={3}>
          <i className="fa fa-umbrella icon-big">&nbsp;</i><br />
          <h3>Jsme platforma studentských spolků a organizací</h3>
        </Col>
        <Col md={3}>
          <i className="fa fa-users icon-big">&nbsp;</i><br />
          <h3>Měníme pohled na občanské vzdělávání mladých lidí</h3>
        </Col>
        <Col md={3}>
          <i className="fa fa-lightbulb-o icon-big">&nbsp;</i><br />
          <h3>Pořádáme interaktivní workshopy a hry pro středoškoláky</h3>
        </Col>
        <Col md={3}>
          <i className="fa fa-line-chart icon-big">&nbsp;</i><br />
          <h3>Usilujeme o aktivní a kriticky smýšlející společnost</h3>
        </Col>
      </Row>
    );
  }
}

export default AboutUs;



// WEBPACK FOOTER //
// ./src/browser/Feature/components/about_us/index.jsx